// import React, { useEffect, useState } from "react";
// import TextSnippetIcon from "@mui/icons-material/TextSnippet";
// import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
// import { Link } from "react-router-dom";
// import withRouter from "../withRouter.js";
// import Footer from "../Component/Footer.js";
// import Menu from "../Component/Menu.js";
// import Header from "../Component/Header.js";
// import { screens } from "../Common/Products.js";
// import UsercustomerService from "../Masters/Usercustomers/UsercustomerService.js";
// import SettingsServices from "../Settings/SettingsServices.js";
// import Credentials, { currentTenant, transactionFrom, userid } from "../Common/Credentials.js";
// import dashboardIcon from "../images/Icons/dashboard.png"
// import transactionsIcon from "../images/Icons/transaction.png"
// import reportsIcon from "../images/Icons/annual-report.png"
// import directtradeIcon from "../images/Icons/agreement.png"
// import posIcon from "../images/Icons/swipe-card.png"
// import { Backdrop } from "@mui/material";
// import "../NewUI/NewMenu.css";
// import Breadcrumb from "../NewUI/NewComponents/Breadcrumb.jsx";

// const SalesMenu = () => {
//   const [hovered, setHovered] = useState(null);
//   const [dnrequired, setDnrequired] = useState(true);
//   const [usercustomers, setUsercustomers] = useState(false);

//   useEffect(() => {
//     Credentials.setSelectedMenu("Sales")
//     SettingsServices.GetSettings(currentTenant).then((response) =>
//       setDnrequired(response.data.dnreq)
//     );
//     UsercustomerService.GetUserCustomersbyUser(userid).then((res) =>
//       setUsercustomers(
//         res.data === "" || res.data === undefined || res.data === null
//           ? false
//           : true
//       )
//     );
//   }, []);

//   return (
//     <div>
//       <Backdrop
//         sx={{
//           color: "#fff",
//           zIndex: (theme) => theme.zIndex.drawer + 1,
//         }}
//         open={transactionFrom === null}
//       >
//         <div className="menu-backdrop-content">
//           <div className="d-flex justify-content-center">
//             <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
//           </div>
//           <div className="d-flex justify-content-center">
//             <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
//           </div>
//         </div>
//       </Backdrop>

//       <Header />
//       <Menu />

//       <section className="content-wrapper">
//         <div className="menu-container">
//           <div className="menu-card">

//             <div className="menu-header">
//               {/* Modern Breadcrumb Navigation */}
//               <Breadcrumb breadcrumbs={[{name:"Home",path:"/index"},{name:"Sales",path:null}]}/>

//               <div className="h-max border-slate-300 bg-white  p-4 rounded-lg menu-content">
//                 <ul className="menu-nav-list">
//                   <li className="menu-nav-item">
//                     <Link
//                       to={{ pathname: "/index" }}
//                       state={{ message: "" }}
//                       className="menu-nav-link"
//                     >
//                       <img className="menu-nav-icon" width="25" src={dashboardIcon} />
//                       <div className="mt-1">Dashboard</div>
//                     </Link>
//                   </li>
//                   {screens.includes("Direct Trade") ? (
//                     <li className="menu-nav-item">
//                       <Link
//                         to={{ pathname: "/directtrade" }}
//                         state={{ message: "" }}
//                         className="menu-nav-link"
//                       >
//                         <img className="menu-nav-icon" width="25" src={directtradeIcon} />
//                         <div className="mt-1">Direct Trade</div>
//                       </Link>
//                     </li>
//                   ) : ""}
//                 </ul>

//                 <div className="menu-sections-container">
//                   <div className="menu-section menu-transactions-section">
//                     <span className="menu-section-title">
//                       <img className="menu-section-icon" width="20" src={transactionsIcon} />
//                       <span className="menu-section-title-text">Transactions</span>
//                     </span>
//                     <ul className="menu-items-list">
//                       {/* {screens.includes("Quotation") ? ( */}
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/quotation" }}
//                             state={{ message: "" }}
//                           >
//                             Quotation
//                           </Link>
//                         </li>
//                       {/* ) : ""} */}
//                       {screens.includes("Sales") || screens.includes("Sale Order") ? (
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/salesorder" }}
//                             state={{ message: "" }}
//                           >
//                             Sale Order
//                           </Link>
//                         </li>
//                       ) : ""}
//                       {screens.includes("Invoice") ? (
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/salesinvoice" }}
//                             state={{ message: "", type: "Tax Invoice" }}
//                           >
//                             Invoice
//                           </Link>
//                         </li>
//                       ) : ""}
//                       {/* {screens.includes("Delivery/Shipment Note") && dnrequired === "YES" ? ( */}
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/deliverynote" }}
//                             state={{ message: "" }}
//                           >
//                             Delivery / Shipment Note
//                           </Link>
//                         </li>
//                       {/* ) : ""} */}
//                       {screens.includes("Sales Returns") ? (
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/salesreturns" }}
//                             state={{ message: "" }}
//                           >
//                             Sales Returns
//                           </Link>
//                         </li>
//                       ) : ""}
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/creditnotes" }}
//                           state={{ message: "" }}
//                         >
//                           Credit Notes
//                         </Link>
//                       </li>
//                       {screens.includes("Receipts") && usercustomers ? (
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/salesreceipts" }}
//                             state={{ message: "" }}
//                           >
//                             Receipts
//                           </Link>
//                         </li>
//                       ) : ""}
//                     </ul>
//                   </div>

//                   {(screens.includes("Point of Sale") || screens.includes("Stock Acceptance") || screens.includes("Pos Price Master")) ? (
//                     <div className="menu-section">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon" width="20" src={posIcon} />
//                         <span className="menu-section-title-text">Point of Sale</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         {screens.includes("Pos Price Master") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/posprice" }}
//                               state={{ message: "" }}
//                             >
//                               Price Master
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("Point of Sale") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/pointofsale" }}
//                               state={{ message: "" }}
//                             >
//                               Point of Sale
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("Stock Acceptance") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/acceptingstockissuetable" }}
//                               state={{ message: "" }}
//                             >
//                               Stock Acceptance
//                             </Link>
//                           </li>
//                         ) : ""}
//                       </ul>
//                     </div>
//                   ) : ""}

//                   <div className="menu-section">
//                     <span className="menu-section-title">
//                       <img className="menu-section-icon-reports" src={reportsIcon} />
//                       <span className="menu-section-title-text">Reports</span>
//                     </span>
//                     <ul className="menu-items-list">
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/salesreport" }}
//                           state={{ message: "" }}
//                         >
//                           Sales Report (Invoice)
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/saleordersreport" }}
//                           state={{ message: "" }}
//                         >
//                           Sale Orders Report
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/salesreturnsreport" }}
//                           state={{ message: "" }}
//                         >
//                           Sales Returns Report
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/hsnsummary" }}
//                           state={{ message: "" }}
//                         >
//                           HSN Summary
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/overdues" }}
//                           state={{ message: "" }}
//                         >
//                           Overdues
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/agentsreports" }}
//                           state={{ message: "" }}
//                         >
//                           Agents Report
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default withRouter(SalesMenu);



import React from 'react';
import {
  FolderLock,
  ArrowRightLeft,
  FileText,
  ChevronRight,
  Blocks,
  Ruler,
  Tag,
  Palette,
  Layers,
  ShoppingBag,
  Wrench,
  DollarSign,
  Boxes,
  ClipboardCopy,
  AlertTriangle,
  FolderSync,
  TrendingDown,
  Warehouse,
  BarChart4,
  ShoppingCart,
  Truck,
  Coins,
  CheckCircle2
} from 'lucide-react';
import path from 'path-browserify';
import withRouter from '../withRouter';
import Footer from '../Component/Footer';
import { Backdrop } from '@mui/material';
import Header from '../Component/Header';
import Menu from '../Component/Menu';
import { theme, transactionFrom } from '../Common/Credentials';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from '../NewUI/NewComponents/Breadcrumb';
import { use } from 'react';
import Layout from '../Component/Layout';

const SalesMenu = () => {
  const navigate = useNavigate();
  // Structure mapping matching the image exactly
  const newsections = [
    {
      title: 'Transactions',
      subtitle: 'Daily customer billing ledgers',
      icon: ArrowRightLeft,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-100 tw-text-blue-600 tw-border-blue-200',
      items: [
        { id: 'quot', label: 'Quotation / Estimate', desc: 'Pre-sales quotations pricing proposals', icon: BarChart4, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-700', path: '/quotation', brandColor: theme === "classic" ? '#4d4d4d' : '#6366F1' },
        { id: 'so', label: 'Sale Order', desc: 'Committed buyer supply orders', icon: ShoppingCart, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-teal-50 hover:tw-bg-teal-100 tw-text-teal-700', path: '/salesorder', brandColor: theme === "classic" ? '#4d4d4d' : '#14B8A6' },
        { id: 'invoices', label: 'Invoice', desc: 'Statutory credit & cash sales bills', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-50 hover:tw-bg-blue-100 tw-text-blue-700', path: '/salesinvoice', brandColor: theme === "classic" ? '#4d4d4d' : '#3B82F6' },
        { id: 'deliv', label: 'Delivery / Shipment Note', desc: 'Outward transport logistics records', icon: Truck, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-purple-50 hover:tw-bg-purple-100 tw-text-purple-705', path: '/deliverynote', brandColor: theme === "classic" ? '#4d4d4d' : '#8B5CF6' },
        { id: 'sal_ret', label: 'Sales Returns', desc: 'Return of goods credit validation', icon: ArrowRightLeft, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-rose-50 hover:tw-bg-rose-100 tw-text-rose-700', path: '/salesreturns', brandColor: theme === "classic" ? '#4d4d4d' : '#F43F5E' },
        { id: 'cred_note', label: 'Credit Note', desc: 'Adjusted customer accounts credit logs', icon: Coins, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 hover:tw-bg-amber-100 tw-text-amber-707', path: '/creditnotes', brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B' }
      ]
    },
    {
      title: 'Point of Sale',
      subtitle: 'Direct retail & checkout operations',
      icon: ShoppingBag,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-100 tw-text-blue-600 tw-border-blue-200',
      items: [
        { id: 'price_master', label: 'Price Master', desc: 'Retail and batch-wise markup parameters', icon: Tag, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-pink-50 hover:tw-bg-pink-100 tw-text-pink-700', path: '/posprice', brandColor: theme === "classic" ? '#4d4d4d' : '#EC4899' },
        { id: 'pos', label: 'Point of Sale', desc: 'Interactive retail till barcode screens', icon: ShoppingCart, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-cyan-50 hover:tw-bg-cyan-100 tw-text-cyan-705', path: '/pointofsale', brandColor: theme === "classic" ? '#4d4d4d' : '#06B6D4' },
        { id: 'stock_acc', label: 'Stock Acceptance', desc: 'Incoming stock confirmation signatures', icon: CheckCircle2, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700', path: '/acceptingstockissuetable', brandColor: theme === "classic" ? '#4d4d4d' : '#10B981' }
      ]
    },
    {
      title: 'Reports',
      subtitle: 'Sales intelligence pipelines',
      icon: FileText,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-100 tw-text-emerald-600 tw-border-emerald-200',
      items: [
        { id: 'rpt_sal', label: 'Sales Report', desc: 'Chronological bills details summary sheets', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700', path: '/salesreport', brandColor: theme === "classic" ? '#4d4d4d' : '#10B981' },
        { id: 'rpt_so', label: 'Sale Orders Report', desc: 'Outstanding active customer orders', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700', path: '/saleordersreport', brandColor: theme === "classic" ? '#4d4d4d' : '#10B981' },
        { id: 'rpt_ret', label: 'Sales Returns Report', desc: 'Return frequency metrics breakdown', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700', path: '/salesreturnsreport', brandColor: theme === "classic" ? '#4d4d4d' : '#10B981' },
        { id: 'rpt_hsn', label: 'HSN Summary Report', desc: 'Approved cargo taxation statistics', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700', path: '/hsnsummary', brandColor: theme === "classic" ? '#4d4d4d' : '#10B981' },
        { id: 'rpt_over', label: 'Overdues Aging Report', desc: 'Pending bills collection ledger', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700', path: '/overdues', brandColor: theme === "classic" ? '#4d4d4d' : '#10B981' }
      ]
    }
  ]


  const onSelectItem = (path) => {
    navigate(path);
  }

  return (
    <div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={transactionFrom === null}
      >
        <div className="menu-backdrop-content">
          <div className="d-flex justify-content-center">
            <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
          </div>
          <div className="d-flex justify-content-center">
            <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
          </div>
        </div>
      </Backdrop>

      <Layout menu={"sales"}>
        <div className="menu-container tw-mr-2 tw-ml-4">
          <div
            id="dashboard-content-area"
            className="tw-flex-1  tw-overflow-y-auto tw-bg-transparent tw-pb-4"
          >
            {/* Upper Hero Grid */}
            <div
              id="hero-welcome-banner"
              className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-items-center tw-bg-white tw-rounded-3xl tw-px-8 tw-border tw-border-slate-200/80 tw-shadow-[0_12px_40px_rgba(0,0,0,0.02)] tw-mb-4 tw-relative tw-overflow-hidden"
            >
              {/* Background Blur Shapes */}
              <div className="tw-absolute tw-top-0 tw-right-0 tw-w-96 tw-h-96 tw-bg-blue-50/40 tw-rounded-full tw-blur-3xl -tw-z-10 tw-translate-x-12 -tw-translate-y-12"></div>

              <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-64 tw-h-64 tw-bg-indigo-50/30 tw-rounded-full tw-blur-3xl -tw-z-10 -tw-translate-x-12 tw-translate-y-12"></div>

              {/* Left Content */}
              <div className="md:tw-col-span-2 tw-text-left tw-space-y-2">
                <Breadcrumb breadcrumbs={[{ name: "Home", path: "/index" }, { name: "Inventory", path: null }]} />

                <h1 className="tw-text-4xl tw-font-extrabold tw-tracking-tight tw-text-slate-900 tw-pt-1">
                  Sales &amp; Point of Sale
                </h1>

                <p className="tw-text-slate-500 tw-font-medium tw-text-[10px] md:tw-text-xs tw-max-w-lg">
                  Track user quotes, manage active retail point of sale billing desks, configure price catalogs, and analyze overdues and sales taxes.
                </p>
              </div>

              {/* Right SVG Illustration */}
              <div className="tw-flex tw-justify-center md:tw-justify-end tw-mt-4 md:tw-mt-0 tw-relative tw-group">
                <div
                  className="tw-w-32 tw-h-32 tw-relative tw-flex tw-items-center tw-justify-center"
                  style={{ animationDuration: '4s' }}
                >
                  <div className="tw-absolute tw-bottom-4 tw-w-32 tw-h-4 tw-bg-slate-300/30 tw-rounded-full tw-blur-md"></div>

                  <svg viewBox="0 0 200 200" className="tw-w-32 tw-h-32 tw-drop-shadow-xl">
                    <defs>
                      <linearGradient id="gridBg" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#1E293B" />
                        <stop offset="100%" stopColor="#0F172A" />
                      </linearGradient>
                      <linearGradient id="lineGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#3B82F6" />
                        <stop offset="50%" stopColor="#8B5CF6" />
                        <stop offset="100%" stopColor="#EC4899" />
                      </linearGradient>
                    </defs>
                    <rect x="20" y="20" width="160" height="160" rx="24" fill="url(#gridBg)" />
                    {/* Chart Grid Lines */}
                    <line x1="40" y1="140" x2="160" y2="140" stroke="#334155" strokeWidth="2" strokeDasharray="4" />
                    <line x1="40" y1="100" x2="160" y2="100" stroke="#334155" strokeWidth="2" strokeDasharray="4" />
                    <line x1="40" y1="60" x2="160" y2="60" stroke="#334155" strokeWidth="2" strokeDasharray="4" />
                    {/* Dynamic spline curve representing sales expansion */}
                    <path d="M40 135 Q 70 120 100 80 T 160 55" fill="none" stroke="url(#lineGrad)" strokeWidth="6" strokeLinecap="round" />
                    {/* Circular points along the spline */}
                    <circle cx="40" cy="135" r="4" fill="#3B82F6" />
                    <circle cx="100" cy="80" r="5" fill="#8B5CF6" />
                    <circle cx="160" cy="55" r="6" fill="#EC4899" className="animate-ping" style={{ animationDuration: '2s' }} />
                    <circle cx="160" cy="55" r="5" fill="#EC4899" />
                  </svg>

                </div>
              </div>
            </div>

            {/* Main Grid */}
            <div
              id="erp-columns-grid"
              className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4"
            >


              {/* Menus */}
              {newsections.map((section) => (
                <div
                  id="section-col-masters"
                  className="tw-bg-white tw-rounded-3xl tw-border tw-border-slate-200/80 tw-p-6 tw-shadow-[0_8px_30px_rgba(0,0,0,0.015)] tw-text-left tw-flex tw-flex-col hover:tw-shadow-lg tw-transition-shadow tw-duration-300"
                >
                  <div className="tw-flex tw-items-center tw-gap-4 tw-mb-6 tw-pb-4 tw-border-b tw-border-slate-100">
                    <div
                      className={`tw-w-12 tw-h-12 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-border ${section.iconColor}`}
                    >
                      <FolderLock size={22} />
                    </div>

                    <div>
                      <h2 className="tw-text-lg tw-font-extrabold tw-text-slate-800">
                        {section.title}
                      </h2>

                      <p className="tw-text-xs tw-text-slate-400 tw-font-medium tw-my-0">
                        {section.subtitle}
                      </p>
                    </div>
                  </div>

                  <div className="tw-space-y-3 tw-flex-1">
                    {section.items.map((item) => {
                      const Icon = item.icon;

                      return (
                        <button
                          id={`subsection-btn-${item.id}`}
                          key={item.id}
                          onClick={() => onSelectItem(item.path)}
                          className="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-2 tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white hover:tw-bg-slate-50 hover:tw-border-slate-300/60 hover:tw-shadow-sm tw-transition-all tw-group tw-duration-200 tw-cursor-pointer tw-text-left"
                        >
                          <div className="tw-flex tw-items-center tw-gap-3.5">
                            <div
                              className={`tw-w-9 tw-h-9 tw-rounded-xl tw-flex tw-items-center tw-justify-center ${item.brandStyle} tw-shrink-0`}
                            >
                              <Icon size={16} color={item.brandColor} />
                            </div>

                            <div>
                              <h4 className="tw-text-sm tw-font-bold tw-text-slate-700 group-hover:tw-text-blue-600 tw-transition-colors">
                                {item.label}
                              </h4>

                              <p className="tw-text-[10px] tw-text-slate-400 tw-font-medium tw-mt-0.5 tw-mb-0">
                                {item.desc}
                              </p>
                            </div>
                          </div>

                          <ChevronRight
                            size={16}
                            className="tw-text-slate-300 group-hover:tw-text-blue-500 group-hover:tw-translate-x-0.5 tw-transition-all"
                          />
                        </button>
                      );
                    })}
                  </div>
                </div>))}
            </div>

          </div>
        </div>
      </Layout>
    </div>
  );
}
export default withRouter(SalesMenu);